import { useEffect, useState, forwardRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { configState } from "../lib/State";
import get_token from "../lib/get_token";
import styled from "@emotion/styled";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import Swal from "sweetalert2";
import {
  Dialog,
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Typography,
  Slide,
  TextField,
} from "@mui/material";
import CenterSelect from "./CenterSelect";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MyDataGrid = styled(DataGrid)`
  min-height: 550px;
`;

const SearchContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 10px;
`;

function RefundCouponDialog(props) {
  const { open, setOpen, login, setCouponName, setCouponSeq, setMbName } = props;
  const token = get_token();
  const [rows, setRows] = useState([]);
  const [names, setNameS] = useState("");
  const [phones, setPhoneS] = useState("");
  const [tcid, setTcid] = useState('');

  const columns = [
    { field: "id", headerName: "id", hide: true },
    {
      field: "regdate",
      headerName: "등록",
      width: 110,
      align: "center",
      renderCell: (params) => {
        return moment(params.row.regdate).format("YYYY.MM.DD");
      },
    },
    {
      field: "mb_name",
      headerName: "이름",
      width: 110,
      align: "center",
    },
    {
      field: "mb_phone_format",
      headerName: "연락처",
      width: 110,
      align: "center",
    },
    {
      field: "gubun",
      headerName: "구분",
      width: 90,
      align: "center",
      renderCell: (params) => {
        return params.row.pt_type === "CLASS" ? "클래스쿠폰" : "패스쿠폰";
      },
    },
    {
      field: "item",
      headerName: "상품명",
      width: 160,
      renderCell: (params) => {
        return params.row.pname;
      },
    },
    { field: "total_amount", headerName: "금액", align: "center", width: 100 },
    { field: "total_count", headerName: "보유", align: "center", width: 70 },
    { field: "use_count", headerName: "사용", align: "center", width: 70 },
    {
      field: "term",
      headerName: "유효기간",
      width: 200,
      align: "center",
      renderCell: (params) => {
        return (
          <>
            {moment(params.row.enroll_sdate).format("YYYY.MM.DD")} -{" "}
            {moment(params.row.enroll_edate).format("YYYY.MM.DD")}
          </>
        );
      },
    },
    {
      field: "state",
      headerName: "상태",
      width: 90,
      align: "center",
      renderCell: (params) => {
        const color = params.row.state === "Y" ? "#3096F4" : "gray";
        return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
      },
    },
  ];

  const onConfirm = (params) => {
    let { id, mb_name, pname, regdate } = params.row;
    regdate = moment(regdate).format("YYYY.MM.DD");

    Swal.fire({
      html: `[${regdate}] [${mb_name}] [${pname}] - 선택 하시겠습니까?`,
      title: "쿠폰선택",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setCouponName(pname);
        setCouponSeq(id);
        setMbName(mb_name);
        setOpen(false);
      }
    });
  };

  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/coupon", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      sname: names,
      sphone: phones,
    });
    setRows(result.data.rows);
  };

  useEffect(() => {
    if (open) {
      load_data();
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={null}
      fullWidth={true}
      maxWidth="lg"
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "static" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography style={{ fontSize: 18 }}>쿠폰찾기</Typography>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <SearchContainer>

        {/* 센터선택 */}
        <Box>
          <CenterSelect            
            login={login}
            tcidParent={tcid}
            setTcidParent={setTcid}
          />
        </Box>        

        <Box sx={{ ml: 1}}>
          <TextField
            sx={{ width: 120 }}
            name="names"
            label="이름"
            size="small"
            onChange={(e) => setNameS(e.target.value)}
            autoComplete="off"
          ></TextField>
        </Box>
        <Box sx={{ ml: 1 }}>
          <TextField
            sx={{ width: 180 }}
            name="phones"
            label="연락처"
            size="small"
            onChange={(e) => setPhoneS(e.target.value)}
            autoComplete="off"
          ></TextField>
        </Box>
        <Box sx={{ ml: 1 }}>
          <Button variant="contained" size="medium" onClick={() => load_data()}>
            찾기
          </Button>
        </Box>
      </SearchContainer>

      <MyDataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[5]}
        checkboxSelection={false}
        onRowClick={(params) => {
          onConfirm(params);
        }}
      />
    </Dialog>
  );
}

export default RefundCouponDialog;
